<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep
      :cardName="prop.cardName"
      :currentStep="prop.type == 'PF_CC' || prop.type == 'EP_CC' ? 16 : 8"
    >
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content2']">
          <div :class="[deviceType, 'frame-grey']">
            <div class="remark">
              {{ t("ccOnBoarding.uploadDocument.remark1") }}
              <br />
              {{ t("ccOnBoarding.uploadDocument.remark2") }}
            </div>
          </div>
          <div v-if="prop.ccForm.ekyc.status == 'COMPLETE'" class="line">
            <div :class="[deviceType, 'separator']">
              <div class="container2">
                <p class="title">
                  {{ t("ccOnBoarding.uploadDocument.proofIdentity") }}
                </p>
                <span
                  v-if="
                    prop.type == 'PF_CC' ||
                    prop.type == 'EP_CC' ||
                    prop.pfExpired
                  "
                >
                  <p class="remarkHeader">
                    {{ t("ccOnBoarding.uploadDocument.upload") }}
                  </p>
                  <p class="remarkHeader">
                    {{ t("ccOnBoarding.uploadDocument.pfProofOfIdentity1") }}
                  </p>
                  <p class="remarkHeader">
                    {{ t("ccOnBoarding.uploadDocument.pfProofOfIdentity2") }}
                  </p>
                </span>
                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey"
                    :id="generateUploadFileId()"
                    @change="uploadFileQuestion1"
                    :file-holder="prop.ccForm.uploadDocument.proofIdentity.file"
                    :file-holder-name="
                      prop.ccForm.uploadDocument.proofIdentity.fileName
                    "
                    :file-number="
                      prop.type == 'CR_SL'
                        ? prop.ccForm.ekyc.completedInCC
                          ? 2 +
                            prop.ccForm.uploadDocument.proofIdentity
                              .fileNumber +
                            prop.ccForm.MosUploadDocument.proofIdentity
                              .fileNumber
                          : prop.ccForm.uploadDocument.proofIdentity
                              .fileNumber +
                            prop.ccForm.MosUploadDocument.proofIdentity
                              .fileNumber
                        : !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
                            !prop.pfExpired
                          ? 2
                          : prop.type == 'EP_CC' ||
                              prop.productBundlingExpiredtype == 'EP_CC'
                            ? prop.ccForm.uploadDocument.proofIdentity
                                .fileNumber +
                              prop.ccForm.EPCCUploadDocument.proofIdentity
                                .fileNumber
                            : prop.ccForm.uploadDocument.proofIdentity
                                .fileNumber
                    "
                    field="upload1"
                    :deletes="
                      prop.type == 'CR_SL'
                        ? true
                        : !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
                            !prop.pfExpired
                          ? false
                          : true
                    "
                    :uploadFileValidity="uploadFileValidity"
                    :errorDisabledSubmitButton="
                      prop.uploadFileValidity.uploadFile1 == 'EC001' ||
                      prop.uploadFileValidity
                        .ThirdPartyUploadIdentityFileValidity ==
                        'invalidFileType'
                    "
                    :type="prop.type"
                  />
                  <pre class="help" v-if="fileSize">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="proofIdentityShowErrorMsg">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'EC001'"
                    >{{
                      t("ccOnBoarding.uploadDocument.invalidFileConversion")
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'EC002'"
                    >{{
                      t("ccOnBoarding.uploadDocument.maliciousFileDetected", {
                        files:
                          uploadFileValidity.maliciousFile1Names.join(", "),
                      })
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'invalidFileType'"
                    >{{ t("ccOnBoarding.uploadDocument.invalidFileType") }}</pre
                  >
                  <pre
                    class="help"
                    v-if="
                      uploadFileValidity.ThirdPartyUploadIdentityFileValidity ==
                      'invalidFileType'
                    "
                    >{{
                      t("ccOnBoarding.uploadDocument.ThirdPartyInvalidFileType")
                    }}</pre
                  >
                  <div v-if="deviceType != 'Mobile'" style="margin-top: 20px">
                    <FileList
                      :question="prop.ccForm.uploadDocument.proofIdentity"
                      :mosIdentityFile="
                        prop.ccForm.MosUploadDocument.proofIdentity
                      "
                      :deletes="
                        !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
                        !prop.pfExpired
                          ? false
                          : true
                      "
                      :status="prop.ccForm.ekyc.status"
                      :type="prop.type"
                      :pfExpired="prop.pfExpired"
                      :filePath="prop.ccForm.imageFilePath"
                      :completedInCC="prop.ccForm.ekyc.completedInCC"
                      :webFormRequestId="prop.webFormRequestId"
                      :uploadFileValidity="uploadFileValidity"
                      :third-party-file="
                        prop.ccForm.EPCCUploadDocument.proofIdentity
                      "
                      :fileType="'identity'"
                    ></FileList>
                  </div>
                </div>
                <div v-if="deviceType == 'Mobile'" class="margin">
                  <p class="uploaded">
                    {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                  </p>
                  <FileList
                    :question="prop.ccForm.uploadDocument.proofIdentity"
                    :mosIdentityFile="
                      prop.ccForm.MosUploadDocument.proofIdentity
                    "
                    :deletes="
                      !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
                      !prop.pfExpired
                        ? false
                        : true
                    "
                    :status="prop.ccForm.ekyc.status"
                    :type="prop.type"
                    :pfExpired="prop.pfExpired"
                    :filePath="prop.ccForm.imageFilePath"
                    :completedInCC="prop.ccForm.ekyc.completedInCC"
                    :webFormRequestId="prop.webFormRequestId"
                    :uploadFileValidity="uploadFileValidity"
                    :third-party-file="
                      prop.ccForm.EPCCUploadDocument.proofIdentity
                    "
                    :fileType="'identity'"
                  ></FileList>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else-if="
              prop.ccForm.ekyc.status != 'COMPLETE' ||
              prop.ccForm.basicInformation.idType == '1'
            "
            class="line"
          >
            <div :class="[deviceType, 'separator']">
              <div class="container2">
                <p class="title">
                  {{ t("ccOnBoarding.uploadDocument.proofIdentity") }}
                </p>
                <div v-if="prop.ccForm.basicInformation.idType != '1'">
                  <p class="remarkHeader">
                    {{ t("ccOnBoarding.uploadDocument.upload") }}
                  </p>
                  <div class="remarkIncomeContainer">
                    <p class="remarkIncome">
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark22") }}
                    </p>
                  </div>
                </div>
                <div v-else>
                  <p class="remarkHeader">
                    {{ t("ccOnBoarding.uploadDocument.upload") }}
                  </p>
                  <div class="remarkIncomeContainer">
                    <p class="remarkIncome">
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark4") }}
                    </p>
                    <p class="remarkIncome">
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark11") }}
                    </p>
                    <p
                      v-if="
                        ccForm.basicInformation.profession != '20' &&
                        prop.ccForm.employmentDetails.question1 == 'No'
                      "
                      class="remarkIncome"
                    >
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark18") }}
                    </p>
                  </div>
                </div>
                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey"
                    :id="generateUploadFileId()"
                    @change="uploadFileQuestion1"
                    :file-holder="prop.ccForm.uploadDocument.proofIdentity.file"
                    :file-holder-name="
                      prop.ccForm.uploadDocument.proofIdentity.fileName
                    "
                    :file-number="
                      prop.type == 'CR_SL'
                        ? prop.ccForm.uploadDocument.proofIdentity.fileNumber +
                          prop.ccForm.MosUploadDocument.proofIdentity.fileNumber
                        : prop.ccForm.uploadDocument.proofIdentity.fileNumber +
                          prop.ccForm.EPCCUploadDocument.proofIdentity
                            .fileNumber
                    "
                    field="upload1"
                    :uploadFileValidity="uploadFileValidity"
                    :errorDisabledSubmitButton="
                      prop.uploadFileValidity.uploadFile1 == 'EC001' ||
                      prop.uploadFileValidity
                        .ThirdPartyUploadIdentityFileValidity ==
                        'invalidFileType'
                    "
                    :type="prop.type"
                  />
                  <pre class="help" v-if="fileSize">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="proofIdentityShowErrorMsg">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'EC001'"
                    >{{
                      t("ccOnBoarding.uploadDocument.invalidFileConversion")
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'EC002'"
                    >{{
                      t("ccOnBoarding.uploadDocument.maliciousFileDetected", {
                        files:
                          uploadFileValidity.maliciousFile1Names.join(", "),
                      })
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'invalidFileType'"
                    >{{ t("ccOnBoarding.uploadDocument.invalidFileType") }}</pre
                  >
                  <pre
                    class="help"
                    v-if="
                      uploadFileValidity.ThirdPartyUploadIdentityFileValidity ==
                      'invalidFileType'
                    "
                    >{{
                      t("ccOnBoarding.uploadDocument.ThirdPartyInvalidFileType")
                    }}</pre
                  >
                  <div
                    v-if="
                      (prop.ccForm.uploadDocument.proofIdentity.fileNumber !=
                        0 ||
                        prop.ccForm.MosUploadDocument.proofIdentity
                          .fileNumber != 0 ||
                        prop.ccForm.EPCCUploadDocument.proofIdentity
                          .fileNumber != 0) &&
                      deviceType != 'Mobile'
                    "
                    style="margin-top: 20px"
                  >
                    <FileList
                      :question="prop.ccForm.uploadDocument.proofIdentity"
                      :mosIdentityFile="
                        prop.ccForm.MosUploadDocument.proofIdentity
                      "
                      :filePath="prop.ccForm.imageFilePath"
                      :type="prop.type"
                      :webFormRequestId="prop.webFormRequestId"
                      :uploadFileValidity="uploadFileValidity"
                      :third-party-file="
                        prop.ccForm.EPCCUploadDocument.proofIdentity
                      "
                      :fileType="'identity'"
                    ></FileList>
                  </div>
                </div>
                <div
                  v-if="
                    (prop.ccForm.uploadDocument.proofIdentity.fileNumber != 0 ||
                      prop.ccForm.MosUploadDocument.proofIdentity.fileNumber !=
                        0 ||
                      prop.ccForm.EPCCUploadDocument.proofIdentity.fileNumber !=
                        0) &&
                    deviceType == 'Mobile'
                  "
                  class="margin"
                >
                  <p class="uploaded">
                    {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                  </p>
                  <FileList
                    :question="prop.ccForm.uploadDocument.proofIdentity"
                    :mosIdentityFile="
                      prop.ccForm.MosUploadDocument.proofIdentity
                    "
                    :filePath="prop.ccForm.imageFilePath"
                    :type="prop.type"
                    :webFormRequestId="prop.webFormRequestId"
                    :uploadFileValidity="uploadFileValidity"
                    :third-party-file="
                      prop.ccForm.EPCCUploadDocument.proofIdentity
                    "
                    :fileType="'identity'"
                  ></FileList>
                </div>
              </div>
            </div>
          </div>

          <div class="line">
            <div :class="[deviceType, 'separator']">
              <div class="container2">
                <p class="title">
                  {{ t("ccOnBoarding.uploadDocument.proofIncome") }}
                </p>
                <p class="remarkHeader">
                  {{ t("ccOnBoarding.uploadDocument.upload") }}
                </p>
                <!-- Malaysian -->
                <div v-if="prop.ccForm.basicInformation.idType != '1'">
                  <div class="remarkIncomeContainer">
                    <!-- Work In Malaysia -->
                    <div
                      v-if="
                        prop.ccForm.basicInformation.profession != '20' &&
                        prop.ccForm.employmentDetails.question2 == 'Yes'
                      "
                    >
                      <!-- Employed -->
                      <div
                        v-if="prop.ccForm.employmentDetails.occupation == '0'"
                      >
                        <!-- Fixed Income -->
                        <div
                          v-if="
                            prop.ccForm.employmentDetails.employmentIncome ==
                            'FI'
                          "
                        >
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark2",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark15",
                              )
                            }}
                          </p>
                        </div>
                        <div
                          v-else-if="
                            prop.ccForm.employmentDetails.employmentIncome ==
                            'VN'
                          "
                        >
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark2",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark15",
                              )
                            }}
                          </p>
                        </div>
                        <div
                          v-else-if="
                            prop.ccForm.employmentDetails.employmentIncome ==
                            'VC'
                          "
                        >
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark2",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark10-1",
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <!--Self Employed -->
                      <div
                        v-else-if="
                          prop.ccForm.employmentDetails.occupation == '1'
                        "
                      >
                        <p class="remarkIncome">
                          {{
                            t("ccOnBoarding.uploadDocument.proofIncomeRemark5")
                          }}
                        </p>
                        <p class="remarkIncome">
                          {{
                            t("ccOnBoarding.uploadDocument.proofIncomeRemark6")
                          }}
                        </p>
                      </div>
                      <!-- Work In Malaysia -->
                    </div>
                    <div
                      v-else-if="
                        prop.ccForm.basicInformation.profession != '20' &&
                        prop.ccForm.employmentDetails.question2 == 'No'
                      "
                    >
                      <div
                        v-if="prop.ccForm.employmentDetails.occupation == '0'"
                      >
                        <div
                          v-if="
                            prop.ccForm.employmentDetails.employmentIncome ==
                            'VC'
                          "
                        >
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark18",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark7",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark10-2",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark9",
                              )
                            }}
                          </p>
                        </div>
                        <div v-else>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark14",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark7",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark8",
                              )
                            }}
                          </p>
                          <p class="remarkIncome">
                            {{
                              t(
                                "ccOnBoarding.uploadDocument.proofIncomeRemark9",
                              )
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-if="prop.ccForm.basicInformation.profession == '20'">
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark5")
                        }}
                      </p>
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark6")
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-else-if="prop.ccForm.basicInformation.idType == '1'">
                  <div v-if="prop.ccForm.employmentDetails.question1 == 'No'">
                    <div
                      v-if="
                        prop.ccForm.employmentDetails.occupation == '1' &&
                        prop.ccForm.basicInformation.profession != '20'
                      "
                    >
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark5")
                        }}
                      </p>
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark6")
                        }}
                      </p>
                    </div>
                    <div
                      v-else-if="
                        prop.ccForm.basicInformation.profession != '20' &&
                        prop.ccForm.employmentDetails.occupation == '0'
                      "
                    >
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark17")
                        }}
                      </p>
                    </div>
                    <div v-if="prop.ccForm.basicInformation.profession == '20'">
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark5")
                        }}
                      </p>
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark6")
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-else-if="prop.ccForm.employmentDetails.question1 == 'Yes'"
                  >
                    <div v-if="prop.ccForm.basicInformation.profession != '20'">
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark20")
                        }}
                      </p>
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark21")
                        }}
                      </p>
                    </div>
                    <div
                      v-else-if="
                        prop.ccForm.basicInformation.profession == '20'
                      "
                    >
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark19")
                        }}
                      </p>
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark20")
                        }}
                      </p>
                      <p class="remarkIncome">
                        {{
                          t("ccOnBoarding.uploadDocument.proofIncomeRemark21")
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey2"
                    :id="generateUploadFileId2()"
                    @change="uploadFileQuestion2"
                    :file-holder="prop.ccForm.uploadDocument.proofIncome.file"
                    :file-holder-name="
                      prop.ccForm.uploadDocument.proofIncome.fileName
                    "
                    :file-number="
                      prop.type == 'CR_SL'
                        ? prop.ccForm.uploadDocument.proofIncome.fileNumber +
                          prop.ccForm.MosUploadDocument.proofIncome.fileNumber
                        : prop.ccForm.uploadDocument.proofIncome.fileNumber +
                          prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber
                    "
                    field="upload2"
                    :uploadFileValidity="uploadFileValidity"
                    :errorDisabledSubmitButton="
                      prop.uploadFileValidity.uploadFile2 == 'EC001' ||
                      prop.uploadFileValidity
                        .ThirdPartyUploadIncomeFileValidity == 'invalidFileType'
                    "
                    :type="prop.type"
                  />
                  <pre class="help" v-if="fileSize2">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="proofIncomeShowErrorMsg">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted2">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile2 == 'EC001'"
                    >{{
                      t("ccOnBoarding.uploadDocument.invalidFileConversion")
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile2 == 'EC002'"
                    >{{
                      t("ccOnBoarding.uploadDocument.maliciousFileDetected", {
                        files:
                          uploadFileValidity.maliciousFile2Names.join(", "),
                      })
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile2 == 'invalidFileType'"
                    >{{ t("ccOnBoarding.uploadDocument.invalidFileType") }}</pre
                  >
                  <pre
                    class="help"
                    v-if="
                      uploadFileValidity.ThirdPartyUploadIncomeFileValidity ==
                      'invalidFileType'
                    "
                    >{{
                      t("ccOnBoarding.uploadDocument.ThirdPartyInvalidFileType")
                    }}</pre
                  >
                  <div
                    v-if="
                      (prop.ccForm.uploadDocument.proofIncome.fileNumber != 0 ||
                        prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber !=
                          0 ||
                        prop.ccForm.MosUploadDocument.proofIncome.fileNumber !=
                          0) &&
                      deviceType != 'Mobile'
                    "
                    style="margin-top: 20px"
                  >
                    <FileList
                      :question="prop.ccForm.uploadDocument.proofIncome"
                      :mosIncomeFile="prop.ccForm.MosUploadDocument.proofIncome"
                      :uploadFileValidity="prop.uploadFileValidity"
                      :filePath="prop.ccForm.imageFilePath"
                      :type="prop.type"
                      :webFormRequestId="prop.webFormRequestId"
                      :third-party-file="
                        prop.ccForm.EPCCUploadDocument.proofIncome
                      "
                      :fileType="'income'"
                    ></FileList>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  (prop.ccForm.uploadDocument.proofIncome.fileNumber != 0 ||
                    prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber !=
                      0 ||
                    prop.ccForm.MosUploadDocument.proofIncome.fileNumber !=
                      0) &&
                  deviceType == 'Mobile'
                "
                class="margin"
              >
                <p class="uploaded">
                  {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                </p>
                <FileList
                  :question="prop.ccForm.uploadDocument.proofIncome"
                  :mosIncomeFile="prop.ccForm.MosUploadDocument.proofIncome"
                  :uploadFileValidity="prop.uploadFileValidity"
                  :filePath="prop.ccForm.imageFilePath"
                  :type="prop.type"
                  :webFormRequestId="prop.webFormRequestId"
                  :third-party-file="prop.ccForm.EPCCUploadDocument.proofIncome"
                  :fileType="'income'"
                ></FileList>
              </div>
            </div>
          </div>
          <div v-if="prop.cardId == 'JC'" class="line">
            <div :class="[deviceType, 'separator']">
              <div class="container2">
                <p class="title">
                  {{ t("ccOnBoarding.uploadDocument.proofJCKLMembershipID") }}
                </p>
                <p class="remarkHeader">
                  {{ t("ccOnBoarding.uploadDocument.upload") }}
                </p>
                <div class="remarkIncomeContainer">
                  <p class="remarkIncome">
                    {{
                      t("ccOnBoarding.uploadDocument.proofJCKLMembershipRemark")
                    }}
                  </p>
                </div>
                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey4"
                    :id="generateUploadFileId4()"
                    @change="uploadFileQuestion4"
                    :file-holder="prop.ccForm.uploadDocument.proofJCKL.file"
                    :file-holder-name="
                      prop.ccForm.uploadDocument.proofJCKL.fileName
                    "
                    :file-number="
                      prop.ccForm.uploadDocument.proofJCKL.fileNumber
                    "
                    field="upload4"
                    :uploadFileValidity="uploadFileValidity"
                  />
                  <pre class="help" v-if="fileSize4">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="upload4">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted4">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile4 == 'EC001'"
                    >{{
                      t("ccOnBoarding.uploadDocument.invalidFileConversion")
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile4 == 'EC002'"
                    >{{
                      t("ccOnBoarding.uploadDocument.maliciousFileDetected", {
                        files:
                          uploadFileValidity.maliciousFile4Names.join(", "),
                      })
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile4 == 'invalidFileType'"
                    >{{ t("ccOnBoarding.uploadDocument.invalidFileType") }}</pre
                  >
                  <div
                    v-if="
                      prop.ccForm.uploadDocument.proofJCKL.fileNumber != 0 &&
                      deviceType != 'Mobile'
                    "
                    style="margin-top: 20px"
                  >
                    <FileList
                      :question="prop.ccForm.uploadDocument.proofJCKL"
                    ></FileList>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  prop.ccForm.uploadDocument.proofJCKL.fileNumber != 0 &&
                  deviceType == 'Mobile'
                "
                class="margin"
              >
                <p class="uploaded">
                  {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                </p>
                <FileList
                  :question="prop.ccForm.uploadDocument.proofJCKL"
                ></FileList>
              </div>
            </div>
          </div>
          <!-- <div class="line">
            <div
              v-if="
                (prop.ccForm.basicInformation.idType == '1' &&
                  prop.ccForm.employmentDetails.question1 != 'No' &&
                  prop.ccForm.basicInformation.profession != '20') ||
                (prop.ccForm.basicInformation.idType == '1' &&
                  prop.ccForm.employmentDetails.question1 != 'No' &&
                  prop.ccForm.basicInformation.profession == '20')
              "
              :class="[deviceType, 'separatorBottom']"
            >
              <div class="container2">
                <p class="title">
                  {{ t("ccOnBoarding.uploadDocument.additionalDoc") }}
                </p>

                <p class="remarkHeader">
                  {{ t("ccOnBoarding.uploadDocument.docReq") }}
                </p>
                <div
                  v-if="prop.ccForm.employmentDetails.occupation == '0'"
                  class="remarkIncomeContainer"
                >
                  <p
                    v-if="prop.ccForm.employmentDetails.question1 == 'Yes'"
                    class="remarkIncome"
                  >
                    {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark13") }}
                  </p>
                  <p class="remarkIncome">
                    {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark11") }}
                  </p>
                  <p class="remarkIncome">
                    {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark12") }}
                  </p>
                  <p class="remarkIncome">
                    {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark17") }}
                  </p>
                </div>

                <div
                  v-if="
                    prop.ccForm.employmentDetails.occupation != '0' &&
                    prop.ccForm.employmentDetails.question1 == 'Yes'
                  "
                  class="remarkIncomeContainer"
                >
            
                  <p class="remarkIncome">
                    {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark13") }}
                  </p>
                </div>

                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey3"
                    :id="generateUploadFileId3()"
                    @change="uploadFileQuestion3"
                    :file-holder="prop.ccForm.uploadDocument.additional.file"
                    :file-holder-name="
                      prop.ccForm.uploadDocument.additional.fileName
                    "
                    :file-number="
                      prop.ccForm.uploadDocument.additional.fileNumber
                    "
                    field="upload3"
                  />
                  <pre class="help" v-if="fileSize3">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="additionalDocShowErrorMsg">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted3">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <div
                    v-if="
                      prop.ccForm.uploadDocument.additional.fileNumber != 0 &&
                      deviceType != 'Mobile'
                    "
                    style="margin-top: 20px"
                  >
                    <FileList
                      :question="prop.ccForm.uploadDocument.additional"
                    ></FileList>
                  </div>
                </div>
                <div
                  v-if="
                    prop.ccForm.uploadDocument.additional.fileNumber != 0 &&
                    deviceType == 'Mobile'
                  "
                  class="margin"
                >
                  <p class="uploaded">
                    {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                  </p>
                  <FileList
                    :question="prop.ccForm.uploadDocument.additional"
                  ></FileList>
                </div>
              </div>
            </div>
          </div> -->
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.uploadDocumentsJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.uploadDocumentsJump == false"
              :disabled="isBtnDisabled"
              :class="[deviceType, 'right-button']"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :class="[deviceType, 'summary-button']"
              :disabled="isBtnDisabled"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
    <PopupMessage
      name="'none'"
      :type="'none'"
      :header="'uploadDocJump'"
      v-if="popup"
      @close-modal="closeTNCModal"
      @submit="submitTNCModal"
      :popup="true"
    >
    </PopupMessage>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeMount, computed, type PropType } from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import professional from "@/enum/Profesinol";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import Constants from "@/constants/constants";
import UploadFile from "./components/NewUploadFileComponent.vue";
import FileList from "./components/UploadedFileList.vue";
import type FormCC from "@/interface/FormCC";
import { pdfRequiresOpenPassword } from "@/utils/pdfRequiresOpenPassword";
import Swal from "sweetalert2";
import { deviceDetect } from "mobile-device-detect";
import Compressor from "compressorjs";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import jpeg from "jpeg-js";
import type { SummarySetting } from "@/interface/FormCC";
import PopupMessage from "./components/PopupMessage.vue";
import { object } from "yup";
import heic2any from "heic2any";

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
  if (
    prop.ccForm.ekyc.status == "COMPLETE" &&
    prop.type != "PF_CC" &&
    prop.type != "EP_CC" &&
    !prop.pfExpired &&
    prop.type != "CR_SL"
  ) {
    prop.ccForm.uploadDocument.proofIdentity.fileNumber = 2;
  }
});

onBeforeMount(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

const jump = () => {
  emit("jumpStep", "10", "", "10");
};

const prop = defineProps({
  ccForm: {
    type: Object as PropType<FormCC>,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  pfExpired: {
    type: Boolean,
    default: false,
  },
  productBundlingExpiredtype: {
    type: String,
    default: "",
  },
  uploadFileValidity: {
    type: Object,
    required: true,
  },
  cardId: {
    type: String,
  },
  webFormRequestId: {
    type: String,
  },
});

const errorMessage = ref("");
const error = ref(true);
const { t } = i18n.global;
const proofIdentityShowErrorMsg = ref(false);
const proofIncomeShowErrorMsg = ref(false);
const additionalDocShowErrorMsg = ref(false);
const upload4 = ref(false);
const popup = ref(false);

const f = ref("Yes");

//List
const titleList = ref([] as string[]);
titleList.value = professional;

const schema = computed(() => {
  return {
    // supplementary: "required",
  };
});

const onInvalidSubmit = () => {
  errorMessage.value = t("ccOnBoarding.uploadDocument.required2");

  if (prop.type === "CR_SL") {
    const ekycComplete =
      prop.ccForm.ekyc.status === "COMPLETE" && prop.ccForm.ekyc.completedInCC;
    const noProofIdentityFiles =
      prop.ccForm.uploadDocument.proofIdentity.fileNumber === 0 &&
      prop.ccForm.MosUploadDocument.proofIdentity.fileNumber === 0;

    if (!ekycComplete && noProofIdentityFiles) {
      proofIdentityShowErrorMsg.value = true;
    }
  } else {
    if (prop.ccForm.uploadDocument.proofIdentity.fileNumber === 0) {
      proofIdentityShowErrorMsg.value = true;
    }
  }

  if (
    prop.ccForm.uploadDocument.proofIncome.fileNumber == 0 &&
    prop.ccForm.MosUploadDocument.proofIncome.fileNumber == 0
  ) {
    proofIncomeShowErrorMsg.value = true;
  }
  if (
    prop.cardId == "JC" &&
    prop.ccForm.uploadDocument.proofJCKL.fileNumber == 0
  ) {
    upload4.value = true;
  }
};

const emit = defineEmits([
  "nextStep",
  "previousStep",
  "jumpStep",
  "submit",
  "close",
  "getProductStep",
]);

const onSubmit = () => {
  if (prop.type === "CR_SL") {
    const ekycComplete =
      prop.ccForm.ekyc.status === "COMPLETE" && prop.ccForm.ekyc.completedInCC;
    const noProofIdentityFiles =
      prop.ccForm.uploadDocument.proofIdentity.fileNumber == 0 &&
      prop.ccForm.MosUploadDocument.proofIdentity.fileNumber == 0;

    if (!ekycComplete && noProofIdentityFiles) {
      proofIdentityShowErrorMsg.value = true;
    }
  } else if (
    prop.type == "EP_CC" ||
    prop.productBundlingExpiredtype == "EP_CC"
  ) {
    if (
      prop.ccForm.uploadDocument.proofIdentity.fileNumber == 0 &&
      prop.ccForm.EPCCUploadDocument.proofIdentity.fileNumber == 0
    ) {
      proofIdentityShowErrorMsg.value = true;
    }
  } else {
    if (prop.ccForm.uploadDocument.proofIdentity.fileNumber == 0) {
      proofIdentityShowErrorMsg.value = true;
    }
  }

  if (prop.type == "CR_SL") {
    if (
      prop.ccForm.uploadDocument.proofIncome.fileNumber == 0 &&
      prop.ccForm.MosUploadDocument.proofIncome.fileNumber == 0
    ) {
      proofIncomeShowErrorMsg.value = true;
    }
  } else if (
    prop.type == "EP_CC" ||
    prop.productBundlingExpiredtype == "EP_CC"
  ) {
    if (
      prop.ccForm.uploadDocument.proofIncome.fileNumber == 0 &&
      prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber == 0
    ) {
      proofIncomeShowErrorMsg.value = true;
    }
  } else {
    if (prop.ccForm.uploadDocument.proofIncome.fileNumber == 0) {
      proofIncomeShowErrorMsg.value = true;
    }
  }
  if (
    prop.cardId == "JC" &&
    prop.ccForm.uploadDocument.proofJCKL.fileNumber == 0
  ) {
    upload4.value = true;
  }

  if (
    proofIdentityShowErrorMsg.value ||
    proofIncomeShowErrorMsg.value ||
    upload4.value ||
    prop.uploadFileValidity.uploadFile1 == "EC001" ||
    prop.uploadFileValidity.uploadFile2 == "EC001" ||
    prop.uploadFileValidity.uploadFile4 == "EC001"
  ) {
  } else {
    if (prop.summarySetting.employmentDetailsJump == true) {
      popup.value = true;
    } else {
      if (prop.type == "CR_SL") {
        for (
          let i = 0;
          i < prop.ccForm.MosUploadDocument.proofIdentity.fileNumber;
          i++
        ) {
          if (
            !isValidThirdPartyFileType(
              prop.ccForm.MosUploadDocument.proofIdentity.fileName[i],
            )
          ) {
            prop.ccForm.MosUploadDocument.proofIdentity.invalidFile[i] = true;
            prop.uploadFileValidity.ThirdPartyUploadIdentityFileValidity =
              "invalidFileType";
          } else {
            prop.ccForm.MosUploadDocument.proofIdentity.invalidFile[i] = false;
          }
        }

        for (
          let i = 0;
          i < prop.ccForm.MosUploadDocument.proofIncome.fileNumber;
          i++
        ) {
          if (
            !isValidThirdPartyFileType(
              prop.ccForm.MosUploadDocument.proofIncome.fileName[i],
            )
          ) {
            prop.ccForm.MosUploadDocument.proofIncome.invalidFile[i] = true;
            prop.uploadFileValidity.ThirdPartyUploadIncomeFileValidity =
              "invalidFileType";
          } else {
            prop.ccForm.MosUploadDocument.proofIncome.invalidFile[i] = false;
          }
        }
      } else if (
        prop.type == "EP_CC" ||
        prop.productBundlingExpiredtype == "EP_CC"
      ) {
        for (
          let i = 0;
          i < prop.ccForm.EPCCUploadDocument.proofIdentity.fileNumber;
          i++
        ) {
          if (
            !isValidThirdPartyFileType(
              prop.ccForm.EPCCUploadDocument.proofIdentity.fileName[i],
            )
          ) {
            prop.ccForm.EPCCUploadDocument.proofIdentity.invalidFile[i] = true;
            prop.uploadFileValidity.ThirdPartyUploadIdentityFileValidity =
              "invalidFileType";
          } else {
            prop.ccForm.EPCCUploadDocument.proofIdentity.invalidFile[i] = false;
          }
        }

        for (
          let i = 0;
          i < prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber;
          i++
        ) {
          if (
            !isValidThirdPartyFileType(
              prop.ccForm.EPCCUploadDocument.proofIncome.fileName[i],
            )
          ) {
            prop.ccForm.EPCCUploadDocument.proofIncome.invalidFile[i] = true;
            prop.uploadFileValidity.ThirdPartyUploadIncomeFileValidity =
              "invalidFileType";
          } else {
            prop.ccForm.EPCCUploadDocument.proofIncome.invalidFile[i] = false;
          }
        }
      }
      if (
        prop.uploadFileValidity.ThirdPartyUploadIdentityFileValidity == "" &&
        prop.uploadFileValidity.ThirdPartyUploadIncomeFileValidity == ""
      ) {
        emit("submit");
      }
    }

    // if (prop.ccForm.uploadDocument.supplementary == "Yes") {
    //   emit("submit");
    // } else {
    //   emit("jumpStep", 10, "", 8);
    // }
  }
};

const isValidThirdPartyFileType = (file: String) => {
  // Check file extension (in case file extension is different but MIME type is still valid)
  const fileExtension = file.split(".").pop()?.toLowerCase();
  const allowedExtensions = ["jpeg", "jpg", "png", "pdf"];

  const isExtensionValid = allowedExtensions.includes(fileExtension || "");

  // Return true if extension are valid
  return isExtensionValid;
};

const handleBack = () => {
  if (prop.type == "PF_CC" || prop.type == "EP_CC") {
    //TODO-Matrix
    emit("getProductStep", false, true, false, false, "");
  } else {
    emit("previousStep");
  }
};

const supplementarySelection = (option: string) => {
  prop.ccForm.uploadDocument.supplementary = option;
  error.value = false;
};

//Proof of Indentity
const generateUploadFileId = () => {
  const fileNameLength =
    prop.ccForm.uploadDocument.proofIdentity.fileName.length;
  return `uploadFileQuestion1N${fileNameLength}`;
};

const planNotEligible = Swal.mixin({
  title: "You are not eligible in this plan.",
  confirmButtonText: "Okay",
  customClass: {
    title: "sweetAlertTitle",
    confirmButton: "sweetAlertConfrimButton",
  },
});

const uploadFileKey = ref(0);
const fileSize = ref(false);
const encrypted = ref(false);

const uploadFileQuestion1 = async () => {
  fileSize.value = false;
  encrypted.value = false;
  const fileId = generateUploadFileId();
  const fileInput = (document.getElementById(fileId) as HTMLInputElement)
    .files?.[0];
  uploadFileKey.value += 1;

  if (fileInput != null) {
    const formData = new FormData();

    const maxSizeBytes = Constants.FILE_SIZE;

    if (fileInput.size > maxSizeBytes) {
      fileSize.value = true;
    } else {
      try {
        if (fileInput.name.toLowerCase().endsWith(".pdf")) {
          const buffer = await fileInput.arrayBuffer();
          if (await pdfRequiresOpenPassword(buffer)) {
            encrypted.value = true;
          } else {
            formData.append("file", fileInput);
            proofIdentityShowErrorMsg.value = false;
            encrypted.value = false;
            prop.ccForm.uploadDocument.proofIdentity.fileName.push(
              fileInput.name,
            );
            prop.ccForm.uploadDocument.proofIdentity.fileNumber =
              prop.ccForm.uploadDocument.proofIdentity.fileName.length;
            prop.ccForm.uploadDocument.proofIdentity.file.push(formData);
          }
        } else {
          //Compress the image
          // const compressedImage = await compressImage(fileInput);
          formData.append("file", fileInput as Blob, fileInput.name);

          // formData.append("file", fileInput);
          proofIdentityShowErrorMsg.value = false;
          encrypted.value = false;
          prop.ccForm.uploadDocument.proofIdentity.fileName.push(
            fileInput.name,
          );
          prop.ccForm.uploadDocument.proofIdentity.fileNumber =
            prop.ccForm.uploadDocument.proofIdentity.fileName.length;
          prop.ccForm.uploadDocument.proofIdentity.file.push(formData);
        }
      } catch {
        encrypted.value = false;
      }
    }
  }
};

// const compressImage = (file: File) => {
//   return new Promise((resolve, reject) => {
//     const fileExtension = file.name.split(".").pop()?.toLowerCase();
//     const allowedExtensions = ["heic", "heif"];
//     if (allowedExtensions.includes(fileExtension || "")) {
//       // Convert HEIC to JPEG first
//       heic2any({ blob: file })
//         .then((convertedFiles: Blob | Blob[]) => {
//           // Check if the result is an array or a single Blob
//           const convertedFile = Array.isArray(convertedFiles)
//             ? convertedFiles[0]
//             : convertedFiles;
//           new Compressor(convertedFile, {
//             quality: 0.5,
//             success(result) {
//               resolve(result);
//             },
//             error(err) {
//               reject(err);
//             },
//           });
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     } else {
//       new Compressor(file, {
//         quality: 0.5,
//         success(result) {
//           resolve(result);
//         },
//         error(err) {
//           reject(err);
//         },
//       });
//     }
//   });
// };

//Proof of Income
const generateUploadFileId2 = () => {
  const fileNameLength = prop.ccForm.uploadDocument.proofIncome.fileName.length;
  return `uploadFileQuestion2N${fileNameLength}`;
};
const uploadFileKey2 = ref(0);
const fileSize2 = ref(false);
const encrypted2 = ref(false);
const uploadFileQuestion2 = async () => {
  fileSize2.value = false;
  encrypted2.value = false;
  const fileId = generateUploadFileId2();
  const fileInput = (document.getElementById(fileId) as HTMLInputElement)
    .files?.[0];
  uploadFileKey2.value += 1;
  if (fileInput != null) {
    const formData = new FormData();

    const maxSizeBytes = Constants.FILE_SIZE;

    if (fileInput.size > maxSizeBytes) {
      fileSize2.value = true;
    } else {
      try {
        if (fileInput.name.toLowerCase().endsWith(".pdf")) {
          const buffer = await fileInput.arrayBuffer();
          if (await pdfRequiresOpenPassword(buffer)) {
            encrypted2.value = true;
          } else {
            formData.append("file", fileInput);
            proofIncomeShowErrorMsg.value = false;
            encrypted2.value = false;
            prop.ccForm.uploadDocument.proofIncome.fileName.push(
              fileInput.name,
            );
            prop.ccForm.uploadDocument.proofIncome.fileNumber =
              prop.ccForm.uploadDocument.proofIncome.fileName.length;
            prop.ccForm.uploadDocument.proofIncome.file.push(formData);
          }
        } else {
          //Compress the image
          // const compressedImage = await compressImage(fileInput);
          formData.append("file", fileInput as Blob, fileInput.name);

          // formData.append("file", fileInput);
          proofIncomeShowErrorMsg.value = false;
          encrypted2.value = false;
          prop.ccForm.uploadDocument.proofIncome.fileName.push(fileInput.name);
          prop.ccForm.uploadDocument.proofIncome.fileNumber =
            prop.ccForm.uploadDocument.proofIncome.fileName.length;
          prop.ccForm.uploadDocument.proofIncome.file.push(formData);
        }
      } catch {
        encrypted2.value = false;
      }
    }
  }
};

//Additional Documents
const generateUploadFileId3 = () => {
  const fileNameLength = prop.ccForm.uploadDocument.additional.fileName.length;
  return `uploadFileQuestion3N${fileNameLength}`;
};
const uploadFileKey3 = ref(0);
const fileSize3 = ref(false);
const encrypted3 = ref(false);
const uploadFileQuestion3 = async () => {
  fileSize3.value = false;
  encrypted3.value = false;
  const fileId = generateUploadFileId3();
  const fileInput = (document.getElementById(fileId) as HTMLInputElement)
    .files?.[0];
  uploadFileKey3.value += 1;
  if (fileInput != null) {
    const formData = new FormData();
    formData.append("file", fileInput);

    const maxSizeBytes = Constants.FILE_SIZE;

    if (fileInput.size > maxSizeBytes) {
      fileSize3.value = true;
    } else {
      try {
        if (fileInput.name.toLowerCase().endsWith(".pdf")) {
          const buffer = await fileInput.arrayBuffer();
          if (await pdfRequiresOpenPassword(buffer)) {
            encrypted3.value = true;
          } else {
            additionalDocShowErrorMsg.value = false;
            encrypted3.value = false;
            prop.ccForm.uploadDocument.additional.fileName.push(fileInput.name);
            prop.ccForm.uploadDocument.additional.fileNumber =
              prop.ccForm.uploadDocument.additional.fileName.length;
            prop.ccForm.uploadDocument.additional.file.push(formData);
          }
        } else {
          // For non-PDF files, proceed with the upload
          additionalDocShowErrorMsg.value = false;
          encrypted3.value = false;
          prop.ccForm.uploadDocument.additional.fileName.push(fileInput.name);
          prop.ccForm.uploadDocument.additional.fileNumber =
            prop.ccForm.uploadDocument.additional.fileName.length;
          prop.ccForm.uploadDocument.additional.file.push(formData);
        }
      } catch {
        encrypted3.value = false;
      }
    }
  }
};

//Proof of JCKL
const generateUploadFileId4 = () => {
  const fileNameLength = prop.ccForm.uploadDocument.proofJCKL.fileName.length;
  return `uploadFileQuestion4N${fileNameLength}`;
};
const uploadFileKey4 = ref(0);
const fileSize4 = ref(false);
const encrypted4 = ref(false);
const uploadFileQuestion4 = async () => {
  fileSize4.value = false;
  encrypted4.value = false;
  const fileId = generateUploadFileId4();
  const fileInput = (document.getElementById(fileId) as HTMLInputElement)
    .files?.[0];
  uploadFileKey4.value += 1;
  if (fileInput != null) {
    const formData = new FormData();

    const maxSizeBytes = Constants.FILE_SIZE;

    if (fileInput.size > maxSizeBytes) {
      fileSize2.value = true;
    } else {
      try {
        if (fileInput.name.toLowerCase().endsWith(".pdf")) {
          const buffer = await fileInput.arrayBuffer();
          if (await pdfRequiresOpenPassword(buffer)) {
            encrypted4.value = true;
          } else {
            formData.append("file", fileInput);
            upload4.value = false;
            encrypted4.value = false;
            prop.ccForm.uploadDocument.proofJCKL.fileName.push(fileInput.name);
            prop.ccForm.uploadDocument.proofJCKL.fileNumber =
              prop.ccForm.uploadDocument.proofJCKL.fileName.length;
            prop.ccForm.uploadDocument.proofJCKL.file.push(formData);
          }
        } else {
          //Compress the image
          // const compressedImage = await compressImage(fileInput);
          formData.append("file", fileInput as Blob, fileInput.name);

          // formData.append("file", fileInput);
          upload4.value = false;
          encrypted4.value = false;
          prop.ccForm.uploadDocument.proofJCKL.fileName.push(fileInput.name);
          prop.ccForm.uploadDocument.proofJCKL.fileNumber =
            prop.ccForm.uploadDocument.proofJCKL.fileName.length;
          prop.ccForm.uploadDocument.proofJCKL.file.push(formData);
        }
      } catch {
        encrypted4.value = false;
      }
    }
  }
};

const isBtnDisabled = computed(() => {
  return prop.type == "CR_SL"
    ? prop.ccForm.ekyc.status == "COMPLETE" && prop.ccForm.ekyc.completedInCC
      ? !(
          prop.ccForm.uploadDocument.proofIncome.fileNumber != 0 ||
          prop.ccForm.MosUploadDocument.proofIncome.fileNumber != 0
        )
      : !(
          (prop.ccForm.uploadDocument.proofIdentity.fileNumber != 0 ||
            prop.ccForm.MosUploadDocument.proofIdentity.fileNumber != 0) &&
          (prop.ccForm.uploadDocument.proofIncome.fileNumber != 0 ||
            prop.ccForm.MosUploadDocument.proofIncome.fileNumber != 0)
        )
    : prop.type == "EP_CC" || prop.productBundlingExpiredtype == "EP_CC"
      ? (prop.ccForm.EPCCUploadDocument.proofIdentity.fileNumber == 0 &&
          prop.ccForm.uploadDocument.proofIdentity.fileNumber == 0) ||
        (prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber == 0 &&
          prop.ccForm.uploadDocument.proofIncome.fileNumber == 0)
      : prop.ccForm.uploadDocument.proofIdentity.fileNumber == 0 ||
        prop.ccForm.uploadDocument.proofIncome.fileNumber == 0 ||
        (prop.cardId == "JC" &&
          prop.ccForm.uploadDocument.proofJCKL.fileNumber == 0);
});

const closeTNCModal = () => {
  popup.value = false;
};

const submitTNCModal = () => {
  emit("submit");
  popup.value = false;
};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.title {
  margin-bottom: 16px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font: 500 20px/130% "Outfit";
  position: relative;
  align-self: stretch;
}
.remarkHeader {
  margin-bottom: 8px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font: 500 16px/130% "Outfit";
  position: relative;
  align-self: stretch;
}

.remarkIncome {
  margin-bottom: 5px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font: 500 16px/130% "Outfit";
  position: relative;
  align-self: stretch;
}

.remarkIncomeContainer {
  margin-bottom: 16px;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.content2 {
  margin-top: 40px;
  padding: 0 8%;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.separator {
  margin-bottom: 32px;
  margin-top: 32px;
  padding: 0 20px;
}

.separatorBottom {
  /* border-bottom: 1px solid #e4e4e4; */
  margin-bottom: 32px;
  margin-top: 32px;
  padding: 0 20px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image:
    linear-gradient(120deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image:
    linear-gradient(120deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.brLine {
  margin-bottom: 18px;
  margin-top: 32px;
}

.frame-grey,
.frame-grey * {
  box-sizing: border-box;
}
.frame-grey {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 24px 32px 24px 32px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.remark {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--subtitle-2-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-2-font-size, 14px);
  line-height: var(--subtitle-2-line-height, 130%);
  font-weight: var(--subtitle-2-font-weight, 500);
  position: relative;
  flex: 1;
}

.uploadFile {
  border-radius: 8px;
  border-style: solid;
  border-color: #e4e4e4;
  border-width: 1px;
  padding: 18px 24px;
  margin-top: 4px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.agree {
  display: flex;
  align-items: flex-start;
}

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet) {
    flex-direction: column;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 40px;
  }
}

.content:is(.Mobile),
.content2:is(.Mobile),
.separator:is(.Mobile),
.separatorBottom:is(.Mobile) {
  padding: 0;
}

.content2:is(.Mobile) {
  margin-top: 0px;
}

.separator .container {
  max-width: none;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.inner-last:is(.Mobile) {
  border-top: 1px solid #e4e4e4;
  padding: 0px 20px;
  border-bottom: 1px solid #e4e4e4;
}

.container:is(.Mobile),
.container2:is(.Mobile) {
  flex-direction: column;
}

.container3:is(.Mobile) {
  max-width: none !important;
}

.container4:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}

.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_third:is(.Mobile) {
  width: 30%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.frame-grey:is(.Mobile) {
  padding: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.margin {
  margin-top: 20px;
}

.uploaded {
  margin-bottom: 15px;
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: left;
  font-family: var(--subtitle-1-medium-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-1-medium-font-size, 16px);
  line-height: var(--subtitle-1-medium-line-height, 130%);
  font-weight: var(--subtitle-1-medium-font-weight, 500);
  position: relative;
  flex: 1;
}
</style>
